// Autogenerated file
export const reportColumnAggregateTypesEnum = {
    None: "None",
    Sum: "Sum",
    Average: "Average",
    Other: "Other",
};
export const reportColumnAggregateTypes = [
    { label: "Без операции", value: "None" },
    { label: "Сумма", value: "Sum" },
    { label: "Среднее", value: "Average" },
    { label: "Другое", value: "Other" },
];
